import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'

import RailsError from '../util/RailsError'
import BillingStore from '../../stores/billing'

function rate(users) {
  if (users >= 200) return 2
  if (users >= 100) return 2.25
  if (users >=  51) return 2.5
  if (users >=  11) return 3
  return 4
}

@inject('users')
@observer
class Users extends Component {
  billing = new BillingStore()

  state = {
    errors: null
  }

  componentDidMount() {
    this.billing.loadLicense()
  }

  addNewUser = event => {
    event.preventDefault()

    const { users } = this.props
    const { name, email, password, admin } = this.form.elements

    const newUser = {
      name: name.value,
      email: email.value,
      password: password.value,
      admin: admin.checked
    }

    users.create(newUser).then(
      () => this.form.reset(),
      ({ response }) => this.setState({ errors: response.data && response.data.errors })
    ).then(
      () => this.billing.loadLicense()
    )
  }

  deleteUser = user => () => this.props.users.delete(user.id).then(() => this.billing.loadLicense())
  
  canDeleteUser(user) {
    if (user.admin && this.props.users.filter( (u) => u.admin ).length ==  1) return false
    return true
  }

  renderUser = user => (
    <tr key={user.id}>
      <td><Link to={`/users/${user.id}`}>{user.name}</Link></td>
      <td><Link to={`/users/${user.id}`}>{user.admin ? 'Admin' : 'Member'}</Link></td>
      <td><Link to={`/users/${user.id}`}>{user.email}</Link></td>
      <td>{this.canDeleteUser(user) && ( <Link to={`/users/delete/${user.id}`} className="danger">Delete</Link> )}</td>
    </tr>
  )

  renderUserBilling() {
    const { license } = this.billing
    if (license) {
      return (
        <ul>
          <li>{Math.max(0, license.free_user_count - license.user_count)} of {license.free_user_count} free user accounts remaining in your plan.</li>
          <li>{Math.max(0, license.additional_user_count)} Additional users added to bill at a rate of ${rate(license.user_count).toFixed(2)}/mo per user.</li>
        </ul>
      )
    }
  }

  renderUsers = users => (
    <div className="panel padded">
      <h2 className="title">Users</h2>
      {this.renderUserBilling()}
      <table className="zebra"><tbody>
        {users.map(user => this.renderUser(user))}
      </tbody></table>
    </div>
  )

  renderNewUserForm = () => {
    const { errors } = this.state

    return (
      <form onSubmit={this.addNewUser} ref={form => this.form = form}>
        <div className="panel padded">
          <h2 className="title">Add A User</h2>

          {errors && <RailsError errors={errors} />}

          <div className="form-section">
            <label htmlFor="name">Name</label>
            <input id="name" name="name" required />
          </div>

          <div className="form-section">
            <label htmlFor="email">Email Address</label>
            <input type="email" id="email" name="email" required />
          </div>

          <div className="form-section">
            <label htmlFor="admin">
              <input type="checkbox" id="admin" name="admin" />
              Admin
            </label>
          </div>

          <div className="form-section">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" name="password" required autoComplete="new-password" />
            <p className="muted">Must be at least 6 characters</p>
          </div>
        </div>
        <button type="submit" className="big shadowed">Create User</button>
      </form>
    )
  }

  render() {
    const { children, users } = this.props

    return (
      <div className="container padded users">
        <div className="half">{children ? React.cloneElement(children, { users }) : this.renderNewUserForm()}</div>
        <div className="half">{this.renderUsers(users)}</div>
      </div>
    )
  }
}

export default Users



// WEBPACK FOOTER //
// client/components/sections/Users.js